/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { useMaterialUIController } from "context";
import { format } from "date-fns";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { SocketContext } from "socket/SocketContext";
import Swal from "sweetalert2";
import { appConstants } from "utils/appConstants";
import { showResMsg, validateField } from "utils/generic";
import { showDraftSavedMessage } from "components/InlineFeedback/DraftSaveConfirmation";
import {
  getFetchCustomerInvoiceBillDetails,
  submitInvoicePayment,
} from "utils/invoiceAPI";

const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // increase the width
  height: "90%x", // increase the height
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const SCREEN_NAME = "Invoice";
let SCREEN_RIGHT;
function InvoicesPayment() {
  const navigate = useNavigate();
  let dispatch = useDispatch();
  const { id: InvoiceID } = useParams();
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [invoiceDocuments, setInvoiceDocuments] = useState([]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState("");
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [paymentModeErr, setPaymentModeErr] = useState(false);
  const [paymentAmountErr, setPaymentAmountErr] = useState(false);
  const [paymentTransactionIDErr, setPaymentTransactionIDErr] = useState(false);
  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
  );
  const socket = useContext(SocketContext);

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
      },
    },
    headCells: {
      style: {
        paddingLeft: "10px",
        paddingRight: "10px",
        fontWeight: "bold",
        fontSize: "14px",
        color: "white",
      },
    },
  };
  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      gst: "",
      discountType: "None",
      discountValue: "",
      discountAmount: "",
    },
  ]);
  const [values, setValues] = useState({
    invoiceNumber: "Auto Generated",
    purchaseOrderNumber: "",
    invoiceDate: new Date(),
    dueDate: new Date(),
    invoiceStatus: "Unpaid",
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    finalAmount: 0,
    payablePendingAmount: 0,
    paymentInstruction: "",
    invoiceType: "Direct",
    currencyValue: "USD",
    contactName: "",
    scheduleRetention: false,
  });
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const [retentionRowsCount, setRetentionRowsCount] = useState(0);
  const [paymentValues, setPaymentValues] = useState({
    userID: loginDetails?._id,
    contactName: "",
    paymentType: "Full Payment",
    paymentAmount: 0.0,
    paymentDate: new Date(new Date() - new Date().getTimezoneOffset() * 60000),
    paymentTransactionID: "",
    paymentMode: "",
    sendEmailFlag: false,
  });
  const [paymentHistory, setPaymentHistory] = useState([]);

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const fetchData = async () => {
    await getFetchCustomerInvoiceBillDetails(
      { invoiceID: InvoiceID },
      (res) => {
        if (res.Result_Output.length > 0) {
          let data = res.Result_Output[0];

          setValues(data);
          data.itemsList?.length > 0 && setItemRowValues(data.itemsList);
          data.documentsList?.length > 0 &&
            setInvoiceDocuments(data.documentsList);
          data.invoicePayment?.length > 0 &&
            setPaymentHistory(data.invoicePayment);
          if (data.retention?.length > 0) {
            setRetentionItemValues(data.retention);
            setRetentionRowsCount(
              data.retention.filter((row) => row.retentionStatus === "Unpaid")
                .length
            );
          }
        } else {
          showResMsg(res.Result_Message, 2000, res.Result_Status);
        }
      },
      dispatch
    );
  };

  let columns = [
    {
      name: "Item Name",
      selector: (row) => row.itemName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "4px" },
    },
    {
      name: "Item Price",
      selector: (row) => row.itemPrice,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Description",
      selector: (row) => row.itemDescription,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Item Quantitiy",
      selector: (row) => row.itemQuantity,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Amount",
      selector: (row) => row.totalItemPrice,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "Account",
      selector: (row) => row.categoryCodeName,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: "GST%",
      selector: (row) => row.gst,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },

    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
    // {
    //   name: `Discount Amount (${values.currencyValue})`,
    //   selector: row => row.discountAmount,
    //   sortable: true,
    //   center: "true",
    //   style: { paddingLeft: "10px" },
    // },
  ];
  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,
      sortable: true,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Action(s)",
      selector: (row) => row,
      center: "true",
      cell: (row) => (
        <>
          <Grid item mt={-3.2}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => {
                handleViewDocument(row);
              }}
              title="View"
            />
          </Grid>
        </>
      ),
    },
  ];
  let columnRetention = [
    {
      name: "Retention No.",
      selector: (row) => row.retentionNumber,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Status`,
      selector: (row) => row.retentionStatus,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Retention Due Date`,
      selector: (row) => row.retentionDueDate,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Payment Amount (${values.currencyValue})`,
      selector: (row) => parseFloat(row.retentionPaymentAmount).toFixed(2),
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
  ];
  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(
      appConstants.baseURL +
        "quotation/viewUploadedQuotationDocument?fileName=/" +
        selectedDocRow.documentFileName
    );
    setViewDocumentInModal(true);
  };
  const handleRowSelected = (state) => {
    values.paymentType = "Retention Payment";
    let selectedAmount = 0;

    state.selectedRows.forEach((row) => {
      if (row.retentionStatus === "Unpaid") {
        selectedAmount += parseFloat(row.retentionPaymentAmount);
      }
    });

    let UnpaidRetention = state.selectedRows.filter(
      (row) => row.retentionStatus === "Unpaid"
    );
    if (UnpaidRetention.length > 0) {
      if (UnpaidRetention.length === retentionRowsCount) {
        values.paymentType = "Full Payment";
      }
    }
    setPaymentValues({
      ...paymentValues,
      retentionInvoiceList: UnpaidRetention,
      paymentType: values.paymentType,
      paymentAmount: selectedAmount.toFixed(2),
    });
  };
  const rowDisabledCriteria = (row) => row.retentionStatus === "Paid";

  const handleChange = (name) => (event) => {
    let inputValue = event.target.value;
    if (name === "paymentAmount") {
      let inputValue = event.target.value;
      if (inputValue === ".") {
        inputValue = "0.";
      }

      const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
      if (regex.test(inputValue) || inputValue === "") {
        if (values.payablePendingAmount >= inputValue) {
          setPaymentValues({ ...paymentValues, [name]: inputValue });
        } else {
          showResMsg(
            "Payment Amount can't be more than Payable Pending Amount",
            1000,
            false
          );
        }
      }
    } else if (name === "paymentType") {
      if (inputValue === "Full Payment") {
        setPaymentValues({
          ...paymentValues,
          [name]: inputValue,
          paymentAmount: values.payablePendingAmount,
        });
      } else {
        setPaymentValues({
          ...paymentValues,
          [name]: inputValue,
          paymentAmount: "",
        });
      }
    } else if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setPaymentValues({ ...paymentValues, [name]: inputValue });
    } else if (event.target.validity === undefined) {
      setPaymentValues({ ...paymentValues, [name]: inputValue });
    }
  };
  const paymentColumns = [
    {
      name: "Payment Date",
      selector: (row) => row.paymentDate,
      sortable: true,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode,
      sortable: true,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Transaction ID",
      selector: (row) => row.paymentTransactionID,
      sortable: true,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      sortable: true,
      style: { paddingLeft: "10px" },
    },
    {
      name: `Paid Amount (${values.currencyValue})`,
      selector: (row) => row.paymentAmount,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Pending Amount (${values.currencyValue})`,
      selector: (row) => row.pendingAmount,
      sortable: true,
      center: "true",
      style: { paddingLeft: "10px" },
    },
  ];
  const clearMandateErr = () => {
    setPaymentAmountErr(false);
    setPaymentModeErr(false);
    setPaymentTransactionIDErr(false);
  };
  const handleSubmitPaymentDetails = async () => {
    try {
      clearMandateErr();

      let mandateFlag = false;
      if (paymentValues.paymentType !== "Full Payment") {
        mandateFlag =
          validateField(paymentValues.paymentAmount, setPaymentAmountErr) ||
          mandateFlag;
        if (parseFloat(paymentValues.paymentAmount) <= 0.0) {
          setPaymentAmountErr(true);
          mandateFlag = true;
        }
      } else if (paymentValues.paymentType === "Retention Payment") {
        if (paymentValues.retentionInvoiceList.length === 0) {
          Swal.fire({
            title: "Choose Retention Invoice!",
            text: `Select atleast one Retention Invoice to proceed!`,
            icon: "question",
          });
          mandateFlag = true;
        }
      } else {
        paymentValues.paymentAmount = values.payablePendingAmount;
      }
      mandateFlag =
        validateField(paymentValues.paymentMode, setPaymentModeErr) ||
        mandateFlag;
      if (
        paymentValues.paymentMode !== "Cash" &&
        paymentValues.paymentMode !== "Cheque"
      ) {
        mandateFlag =
          validateField(
            paymentValues.paymentTransactionID,
            setPaymentTransactionIDErr
          ) || mandateFlag;
      }
      if (mandateFlag) return;
      paymentValues.invoiceID = InvoiceID;
      paymentValues.signatureKey = appConstants.SIGNATURE_KEY;
      ShowSwalWithButtons(
        "Are you sure?",
        `Would you like to submit the ${
          paymentValues.paymentType +
          " " +
          values.currencyValue +
          parseFloat(paymentValues.paymentAmount).toFixed(2)
        } of Invoice ${values.invoiceNumber}`,
        "warning",
        darkMode,
        () => {
          submitInvoicePayment(
            paymentValues,
            (data) => {
              if (data.Result_Status) showDraftSavedMessage("Payment recorded successfully");
              else showResMsg(data.Result_Message, 2000, false);
              console.log("data333", data);
              if (data.Result_Status) {
                console.log("data", data);
                setPaymentValues((prev) => ({
                  ...prev,
                  paymentAmount: 0.0,
                  paymentTransactionID: "",
                  paymentMode: "",
                  sendEmailFlag: false,
                  retentionInvoiceList: [],
                }));

                fetchData();
              }
              socket.emit("message", {
                businessUserID: loginDetails?.businessUserID,
              });
            },
            dispatch
          );
        }
      );
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: `Would you like to submit the ${paymentValues.paymentType + " " + values.currencyValue + parseFloat(paymentValues.paymentAmount).toFixed(2)} of Invoice ${values.invoiceNumber}?`,
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#4CAF50",
      //   cancelButtonColor: "#6c757d",
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "No",
      //   reverseButtons: "true",
      //   customClass: {
      //     confirmButton: 'confirm-buttonss',
      //     cancelButton: 'deny-buttonss',
      //   }
      // }).then(async (result) => {
      //   if (result.isConfirmed) {
      //     await submitInvoicePayment(paymentValues, (data) => {
      //       showResMsg(data.Result_Message, 2000, data.Result_Status);
      //       if (data.Result_Status) {
      //         setPaymentValues({
      //           ...paymentValues,
      //           paymentAmount: 0.00,
      //           paymentTransactionID: "",
      //           paymentMode: "",
      //           sendEmailFlag: false,
      //         })
      //         fetchData();
      //       }
      //       socket.emit('message', { businessUserID: loginDetails?.businessUserID });
      //     }, dispatch);
      //   }
      // });
    } catch (error) {
      dispatch(loadingAction(false));
      console.error("Error in handleSubmitPaymentDetails:", error.message);
    }
  };
  const handleSaveWithSendEmail = () => {
    try {
      paymentValues.sendEmailFlag = true;
      handleSubmitPaymentDetails();
    } catch (error) {
      console.log("Error in handleSaveAndSendEmail:", error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid sx={{ mt: "20px" }}>
        <Card
          color="primary"
          sx={{ pb: 2, boxShadow: "3px 3px 3px 3px #cdcdcd" }}
        >
          <PageTitle screenName="Payment for Invoice" />
          <Grid container px={2} mt={2} spacing={2}>
            {/* Invoice Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Number"
                variant="outlined"
                disabled
                fullWidth
                value={values.invoiceNumber}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* Invoice Type */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Type"
                variant="outlined"
                disabled
                fullWidth
                value={values.invoiceType}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* Invoice Type */}
            {values.invoiceType === "Through Quotation" && (
              <Grid item lg={3} xs={6}>
                <TextField
                  type="text"
                  label="Quotation"
                  variant="outlined"
                  disabled
                  fullWidth
                  value={values.quotationNumber}
                  inputProps={{
                    className: "custom-fieldtext",
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            )}
            {/* contact Name Dropdown */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Customer"
                variant="outlined"
                disabled
                fullWidth
                value={values.contactName}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            {/* Reference Number */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Reference Number "
                variant="outlined"
                placeholder="Optional"
                fullWidth
                value={values.purchaseOrderNumber}
                inputProps={{
                  className: "custom-fieldtext",
                  maxLength: 50,
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Invoice Date"
                variant="outlined"
                fullWidth
                value={values.invoiceDate}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            {/* dueDate */}
            <Grid item lg={3} xs={6}>
              <TextField
                type="text"
                label="Due Date"
                variant="outlined"
                fullWidth
                value={values.dueDate}
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>

            <Grid item lg={3} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  disabled
                  label="Status"
                  value={values.invoiceStatus}
                >
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                  <MenuItem value="Partial Paid">Partial Paid</MenuItem>
                  <MenuItem value="Paid">Paid</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12} px={2} md={4} lg={12} sx={{ mt: 1 }}>
            <MDTypography
              variant="button"
              fontWeight="bold"
              color="text"
              sx={{ cursor: "default", userSelect: "none" }}
            >
              Invoice Item(s)
            </MDTypography>
          </Grid>
          <CardContent>
            <DataTable
              columns={columns}
              data={itemRowValues}
              customStyles={customStyles}
              fixedHeaderScrollHeight="210px"
              fixedHeader={true}
            />
          </CardContent>
          <Grid container px={2} pt={2} pb={2} spacing={2} mt={1}>
            <Grid item lg={3} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">GST Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "35.11px" }}
                  label="GST Type"
                  value={values.gstType || "Inclusive"}
                  disabled
                >
                  <MenuItem value="Inclusive">Inclusive</MenuItem>
                  <MenuItem value="Exclusive">Exclusive</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Amount (${values.currencyValue})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalAmount}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Total Discount Amount (${values.currencyValue})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.totalDiscountAmount}
              />
            </Grid>
            <Grid item lg={3} xs={12}>
              <TextField
                type="text"
                label={`Final Invoice Amount (${values.currencyValue})`}
                variant="outlined"
                fullWidth
                inputProps={{
                  className: "custom-fieldtext",
                }}
                InputLabelProps={{ shrink: true }}
                disabled
                value={values.finalAmount}
              />
            </Grid>

            <Grid item lg={12} xs={12}>
              <TextField
                type="text"
                label="Payment Instructions"
                variant="outlined"
                fullWidth
                value={values.paymentInstruction}
                disabled
              />
            </Grid>
          </Grid>
          {invoiceDocuments.length > 0 && (
            <>
              <Grid item xs={12} px={2} md={4} lg={12}>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  color="text"
                  sx={{ cursor: "default", userSelect: "none" }}
                >
                  Invoice Documents
                </MDTypography>
              </Grid>
              <CardContent>
                <DataTable
                  columns={documentColumns}
                  data={invoiceDocuments}
                  fixedHeaderScrollHeight="210px"
                  fixedHeader={true}
                  customStyles={customStyles}
                />
              </CardContent>
            </>
          )}
        </Card>
        <Card color="success" sx={{ mt: 2 }}>
          <Grid item px={2} pt={1} xs={12} md={4} lg={12} mt={2}>
            <p
              style={{ fontSize: "14px", fontWeight: "bold", color: "#008000" }}
            >
              Invoice Bill Payment
            </p>
          </Grid>
          {values.scheduleRetention && retentionItemValues.length > 0 && (
            <CardContent>
              <DataTable
                columns={columnRetention}
                data={retentionItemValues}
                customStyles={customStyles}
                fixedHeaderScrollHeight="185px"
                fixedHeader={true}
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                selectableRowDisabled={rowDisabledCriteria}
              />
            </CardContent>
          )}
          {parseFloat(values.payablePendingAmount) > 0 && (
            <>
              <Grid container px={2} mt={2} spacing={2} mb={2}>
                <Grid item lg={2} xs={6}>
                  <TextField
                    type="text"
                    label={`Pending Invoice Amount (${values.currencyValue})`}
                    variant="outlined"
                    placeholder={`Invoice Amount (${values.currencyValue})`}
                    fullWidth
                    disabled
                    value={`${parseFloat(values.payablePendingAmount).toFixed(
                      2
                    )}`}
                    inputProps={{
                      className: "custom-fieldtext",
                    }}
                  />
                </Grid>
                <Grid item lg={2} xs={6}>
                  <TextField
                    type="text"
                    label="Payment Date"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={format(
                      new Date(paymentValues.paymentDate),
                      "MMM dd, yyyy"
                    )}
                    disabled
                    inputProps={{
                      className: "custom-fieldtext",
                    }}
                  />
                </Grid>
                <Grid item lg={2} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Payment Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ height: "35.11px" }}
                      label="Payment Type"
                      autoFocus
                      value={paymentValues.paymentType}
                      onChange={handleChange("paymentType")}
                      inputProps={{
                        className: "custom-fieldtext",
                      }}
                    >
                      {values.scheduleRetention &&
                        retentionItemValues.length > 0 && (
                          <MenuItem value="Retention Payment">
                            Retention Payment
                          </MenuItem>
                        )}
                      {!values.scheduleRetention && (
                        <MenuItem value="Partial Payment">
                          Partial Payment
                        </MenuItem>
                      )}
                      <MenuItem value="Full Payment">Full Payment</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item lg={2} xs={6}>
                  <TextField
                    type="text"
                    label="Payment Mode"
                    variant="outlined"
                    placeholder="Payment Mode"
                    fullWidth
                    autoFocus
                    inputProps={{
                      maxLength: 30,
                      pattern: "^[a-zA-Z0-9 ]+$",
                    }}
                    value={paymentValues.paymentMode}
                    onChange={handleChange('paymentMode')}
                  />
                  {paymentModeErr ? <p style={errMsg}>Payment Mode can't be blank.</p> : ""}
                </Grid> */}
                <Grid item lg={2} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Payment Mode
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ height: "35.11px" }}
                      label="Payment Mode"
                      onChange={handleChange("paymentMode")}
                      value={paymentValues.paymentMode}
                      inputProps={{
                        className: "custom-fieldtext",
                      }}
                    >
                      <MenuItem value="">Select Payment Mode</MenuItem>
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="Paypal">Paypal</MenuItem>
                      <MenuItem value="Card">Card</MenuItem>
                      <MenuItem value="Cheque">Cheque</MenuItem>
                      <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                      <MenuItem value="Wire Transfer">Wire Transfer</MenuItem>
                    </Select>
                  </FormControl>
                  {paymentModeErr ? (
                    <p style={errMsg}>Payment Mode can't be blank.</p>
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid item lg={2} xs={6}>
                  {paymentValues.paymentMode === "Cash" ? (
                    <TextField
                      type="text"
                      label="Transaction ID"
                      variant="outlined"
                      placeholder="Transaction ID"
                      fullWidth
                      inputProps={{
                        className: "custom-fieldtext",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      // value={paymentValues.paymentTransactionID}
                      // onChange={handleChange('paymentTransactionID')}
                      disabled
                    />
                  ) : (
                    <TextField
                      type="text"
                      label="Transaction ID"
                      variant="outlined"
                      placeholder="Transaction ID"
                      fullWidth
                      inputProps={{
                        className: "custom-fieldtext",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={paymentValues.paymentTransactionID}
                      onChange={handleChange("paymentTransactionID")}
                    />
                  )}
                  {paymentTransactionIDErr ? (
                    <p style={errMsg}>Transaction ID can't be blank.</p>
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid item lg={2} xs={6}>
                  {paymentValues.paymentType === "Full Payment" ? (
                    <TextField
                      type="text"
                      label={`Payment Amount (${values.currencyValue})`}
                      variant="outlined"
                      placeholder={`Payment Amount (${values.currencyValue})`}
                      fullWidth
                      inputProps={{
                        className: "custom-fieldtext",
                      }}
                      disabled
                      value={`${parseFloat(values.payablePendingAmount).toFixed(
                        2
                      )}`}
                    />
                  ) : (
                    <TextField
                      type="text"
                      label={`Payment Amount (${values.currencyValue})`}
                      variant="outlined"
                      fullWidth
                      disabled={values.scheduleRetention}
                      onChange={handleChange("paymentAmount")}
                      value={`${paymentValues.paymentAmount}`}
                    />
                  )}
                  {paymentAmountErr ? (
                    <p style={errMsg}>Payment Amount can't be blank or zero.</p>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>

              <Grid
                container
                mt={2}
                pb={3}
                // columnSpacing={4}
                spacing={2}
                // alignItems="center"
                // display="flex"
                justifyContent="center"
              >
                <Grid
                  item
                  container
                  lg={2.1}
                  xs={12}
                  md={4}
                  justifyContent="center"
                >
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    // fullWidth
                    style={{ minWidth: "165px", height: "40px" }}
                    onClick={() => {
                      navigate("/invoices");
                    }}
                  >
                    Close
                  </MDButton>
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  md={4}
                  lg={2.1}
                  justifyContent="center"
                >
                  <MDButton
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    // fullWidth

                    style={{ minWidth: "165px", height: "40px" }}
                    onClick={handleSubmitPaymentDetails}
                  >
                    Submit
                  </MDButton>
                </Grid>
                {parseFloat(values.payablePendingAmount) > 0 && (
                  <Grid
                    container
                    item
                    xs={12}
                    md={4}
                    lg={2.1}
                    justifyContent="center"
                  >
                    <MDButton
                      rel="noreferrer"
                      variant="gradient"
                      color="info"
                      // fullWidth

                      style={{ minWidth: "165px", height: "40px" }}
                      onClick={handleSaveWithSendEmail}
                    >
                      Save & Send Email
                    </MDButton>
                  </Grid>
                )}
              </Grid>
            </>
          )}

          {paymentHistory?.length > 0 && (
            <CardContent sx={{ mb: 2 }}>
              <DataTable
                columns={paymentColumns}
                data={paymentHistory}
                fixedHeaderScrollHeight="210px"
                fixedHeader={true}
                customStyles={customStyles}
              />
            </CardContent>
          )}
          {parseFloat(values.payablePendingAmount) === 0 && (
            <Grid
              container
              mt={2}
              pb={3}
              columnSpacing={4}
              alignItems="center"
              display="flex"
              justifyContent="center"
            >
              <Grid item xs={12} md={4} lg={1.8}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                  // onClick={() => { navigate(-1) }}
                  onClick={() => {
                    navigate("/invoices");
                  }}
                >
                  Close
                </MDButton>
              </Grid>
            </Grid>
          )}
        </Card>
      </Grid>

      <Modal
        className="document-preview-overlay"
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          "& .MuiModal-root": {
            width: "100%",
            height: "100%",
          },
        }}
      >
        <Card sx={pdfStyle}>
          <Box>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              File Viewer
            </Typography>
            <iframe
              title="File Viewer"
              src={getDocumentFileURL}
              width="100%"
              height="650"
              className="ressst"
              allowFullScreen={true}
            ></iframe>

            <Grid
              container
              id="modal-modal-description"
              sx={{ mt: 2, justifyContent: "center" }}
            >
              <MDButton
                color="warning"
                className="modalButton"
                onClick={() => {
                  setViewDocumentInModal(false);
                }}
              >
                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default InvoicesPayment;
